import type { MangaItem } from '@/mocks/manga';

interface Props {
  item: MangaItem;
  onOpen: (item: MangaItem) => void;
}

export default function MangaCard({ item, onOpen }: Props) {
  return (
    <article
      onClick={() => onOpen(item)}
      className="group flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-200 hover:shadow-lg"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={item.cover}
          alt={`${item.title} 漫画封面`}
          title={`${item.title} 高清原版`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute left-2 top-2 flex flex-wrap gap-1">
          {item.preview && (
            <span className="inline-flex items-center gap-0.5 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-bold text-background-50">
              <i className="ri-flashlight-fill text-[10px]"></i>抢先看
            </span>
          )}
          {item.exclusive && (
            <span className="inline-flex items-center rounded-md bg-primary-500 px-2 py-0.5 text-[11px] font-bold text-background-50">
              独家
            </span>
          )}
        </div>
        {item.uncensored && (
          <span className="absolute right-2 top-2 rounded-md bg-background-950/80 px-2 py-0.5 text-[11px] font-semibold text-background-50">
            未删减
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background-950/80 to-transparent px-3 pb-2 pt-6">
          <span className="text-xs font-semibold text-background-50">{item.status} · 全 {item.episodes} 话</span>
        </div>
      </div>

      <div className="flex flex-1 flex-col gap-2 p-3">
        <h3 className="truncate text-sm font-bold text-foreground-950 md:text-base">{item.title}</h3>
        <p className="text-xs text-foreground-600 md:text-sm">{item.altTitle}</p>
        <div className="mt-auto flex items-center justify-between text-xs">
          <span className="inline-flex items-center gap-1 rounded-full bg-primary-50 px-2 py-0.5 font-medium text-primary-700">
            {item.category}
          </span>
          <span className="flex items-center gap-2">
            <span className="flex items-center gap-0.5 text-accent-600">
              <i className="ri-star-fill text-accent-500"></i>
              {item.rating}
            </span>
            <span className="text-foreground-500">{item.views}</span>
          </span>
        </div>
        <div className="flex items-center justify-between border-t border-background-100 pt-2 text-xs">
          <span className="truncate text-foreground-700">{item.latest}</span>
          <span className="whitespace-nowrap font-semibold text-primary-600">{item.updateTime}</span>
        </div>
      </div>
    </article>
  );
}